export default __webpack_public_path__ + "static/media/step_07.e21ccbaf.png";